import React, { useState } from "react";
import PropTypes from "prop-types";
import EnterPhone from "./EnterPhone";
import EnterCode from "./EnterCode";
import { UPDATE_PHONE_STATUS_CODES } from "shared/mutations/sms";

const STEPS = {
	PHONE: "PHONE",
	CODE: "CODE",
};

const PhoneVerificationFlow = ({
	handlePhoneVerified,
	showContactSupport,
	showLogoutIfPhoneTakenOption,
	dialingCode,
	phoneNumber,
}) => {
	const [step, setStep] = useState(STEPS.PHONE);
	const [showPhoneTakenError, setShowPhoneTakenError] = useState(false);

	return (
		<>
			{step === STEPS.PHONE &&
				<EnterPhone
					phoneNumber={phoneNumber}
					dialingCode={dialingCode}
					handleSuccess={() => setStep(STEPS.CODE)}
					showPhoneTakenError={showLogoutIfPhoneTakenOption && showPhoneTakenError}
				/>}
			{step === STEPS.CODE &&
				<EnterCode
					phoneNumber={`${dialingCode}${phoneNumber}`}
					handleSuccess={handlePhoneVerified}
					showContactSupport={showContactSupport}
					goBackToPhone={(statusCode) => {
						if (statusCode === UPDATE_PHONE_STATUS_CODES.PHONE_TAKEN) {
							setShowPhoneTakenError(true);
						}

						setStep(STEPS.PHONE);
					}}
				/>}
		</>
	);
};

PhoneVerificationFlow.propTypes = {
	handlePhoneVerified: PropTypes.func.isRequired,
	showContactSupport: PropTypes.bool,
	showLogoutIfPhoneTakenOption: PropTypes.bool,
	dialingCode: PropTypes.string.isRequired,
	phoneNumber: PropTypes.string.isRequired,
};

PhoneVerificationFlow.defaultProps = {
	showContactSupport: false,
	showLogoutIfPhoneTakenOption: false,
};

export default PhoneVerificationFlow;





// WEBPACK FOOTER //
// ./src/shared/components/Sms/PhoneVerificationFlow.jsx